import { Link } from '@tanstack/react-router'
import { CatalogGridViewModel } from '@/components/catalog/catalog-grid/catalog-grid.view-model'
import type { useProductPageModel } from '@/components/product/product-page/product-page.model'
import { ContactCtaViewModel } from '@/components/shared/contact-cta/contact-cta.view-model'
import { ProductPlaceholderViewModel } from '@/components/shared/product-placeholder/product-placeholder.view-model'

type ProductPageViewProps = ReturnType<typeof useProductPageModel>

export function ProductPageView({
  product,
  categoryLabel,
  formattedPrice,
  siblings,
  hasSiblings,
  photoRef,
  siblingsContainerRef,
}: ProductPageViewProps) {
  return (
    <article className="fz-product-page">
      <section className="fz-product-page__hero">
        <div ref={photoRef} className="fz-product-page__photo">
          <div className="fz-product-page__photo-inner">
            {product.imagePath ? (
              <img
                src={product.imagePath}
                alt={product.name}
                className="fz-product-page__image"
              />
            ) : (
              <ProductPlaceholderViewModel
                name={product.name}
                category={product.category}
              />
            )}
          </div>
        </div>
        <div className="fz-product-page__content">
          <Link
            to="/catalogo/$categoria"
            params={{ categoria: product.category }}
            className="fz-product-page__eyebrow"
          >
            {categoryLabel}
          </Link>
          <h1 className="fz-product-page__name">{product.name}</h1>
          <p className="fz-product-page__story">{product.shortStory}</p>
          <div className="fz-product-page__price-block">
            <span className="fz-product-page__price-label">A partir de</span>
            <span className="fz-product-page__price">{formattedPrice}</span>
          </div>
          <ContactCtaViewModel
            productName={product.name}
            label="Encomendar por e-mail"
          />
          <p className="fz-product-page__trigger">
            Você fala direto com o ateliê, sem cadastro.
          </p>
          <p className="fz-product-page__trust">
            Buquês montados à mão · Entrega em toda a cidade · Encomenda por
            e-mail
          </p>
        </div>
      </section>
      {hasSiblings ? (
        <section className="fz-product-page__siblings">
          <h2 className="fz-product-page__siblings-title">Da mesma família</h2>
          <div ref={siblingsContainerRef}>
            <CatalogGridViewModel products={siblings} />
          </div>
        </section>
      ) : null}
    </article>
  )
}
